import {Button} from 'antd';
import StatusUpdateModal from '../CommonModal';
import {maxTagPlaceholder, tagRender} from '../../../Util/commonUtility';

// Renders the "Approve refund" modal (percentage/exact-amount + direct/credit) and its
// trigger buttons. Shared by the per-event refund page (EventRefund) and the cross-event
// refund page (AllRefund) so both stay in sync — pair with useRefundApproval for the state.
const RefundApprovalFooter = ({
  showApproveReject,
  isModalVisible,
  hideModal,
  handleRadioChange,
  refundToAccount,
  setRefundToAccount,
  handleInputChange,
  percentageRefund,
  refundMode,
  handleRefundModeChange,
  exactAmountRefund,
  selectedRowProcessingFee,
  selectedRowProcessingFeePercentage,
  handleRefundAmountChange,
  handleApproveRefunds,
  refundSubmitting = false,
  selectedRowTotalRefundAmount,
  selectedRowCreditAmount,
  selectedRowPaidAmount,
  selectedRowPaidAmountWithFee,
  selectedRowStripePaymentIds,
  selectedRowTotalDiscount,
  localChapterData,
  handleRefundVisible,
  handleCancelRefund,
  creditOnlyRefund = false,
}) => {
  if (!showApproveReject) {
    return null;
  }

  return (
    <div className='refund-admin-container'>
      <StatusUpdateModal
        statusHeading='Select Mode and Amount For Refund'
        visible={isModalVisible}
        onCancel={hideModal}
        submitText='Refund'
        mode={'tags'}
        maxTagCount={'responsive'}
        maxTagPlaceholder={maxTagPlaceholder}
        tagRender={tagRender}
        handleRadioChange={handleRadioChange}
        selectedRowProcessingFee={selectedRowProcessingFee}
        selectedRowProcessingFeePercentage={selectedRowProcessingFeePercentage}
        refundToAccount={refundToAccount}
        refundBoolForAdmin={true}
        handleRefundAdminInputChange={handleInputChange}
        percentageRefund={percentageRefund}
        refundMode={refundMode}
        handleRefundModeChange={handleRefundModeChange}
        exactAmountRefund={exactAmountRefund}
        handleRefundAmountChange={handleRefundAmountChange}
        setRefundToAccount={setRefundToAccount}
        handleUpdateJobStatus={handleApproveRefunds}
        submitLoading={refundSubmitting}
        selectedRowTotalRefundAmount={selectedRowTotalRefundAmount}
        selectedRowCreditAmount={selectedRowCreditAmount}
        selectedRowPaidAmount={selectedRowPaidAmount}
        selectedRowPaidAmountWithFee={selectedRowPaidAmountWithFee}
        selectedRowStripePaymentIds={selectedRowStripePaymentIds}
        selectedRowTotalDiscount={selectedRowTotalDiscount}
        localChapterData={localChapterData}
        creditOnlyRefund={creditOnlyRefund}
      />
      <Button
        type='primary'
        onClick={handleRefundVisible}
        id='EventRefundComponent-button-backToEvent'
        className='common-submit-login common-form-submit'>
        Approve
      </Button>
      <Button
        type='default'
        onClick={handleCancelRefund}
        id='EventRefundComponent-button-backToEvent'
        className='common-submit-login common-form-submit'>
        Cancel
      </Button>
    </div>
  );
};

export default RefundApprovalFooter;
